<div class="settings-item !items-start">
    <div class="heading-wrapper">
        <div class="description">
            <div class="settings-header">
                <div class="with-label">
                    Track All Controlled Substances and Drugs of Interest
                    <app-badge [color]="BadgeColorsEnum.Green">beta</app-badge>
                </div>
            </div>
            <div *ngIf="!enableC3toC5Drugs; else elseBlock" class="settings-sub-header">
                Turn on the ability to track and report Schedule III, IV, V, Gabapentin, and Pseudoephedrine activities.
            </div>
            <ng-template #elseBlock>
                <div class="flex flex-row">
                    <div class="checkmark-rounded mt-[2px] ml-1"></div>
                    <div *ngIf="(enableC3toC5DrugsValue$ | async)?.DrugsOfInterestType === DrugActivitiesToTrackEnum.AllAndDrugsOfInterest"
                        class="settings-sub-header">
                        <ng-container *ngTemplateOutlet="drugsAll"></ng-container>
                    </div>
                    <div *ngIf="(enableC3toC5DrugsValue$ | async)?.DrugsOfInterestType === DrugActivitiesToTrackEnum.CABoard"
                        class="settings-sub-header">
                        <ng-container *ngTemplateOutlet="drugsSelected"></ng-container>
                    </div>
                </div>
            </ng-template>
    
        </div>
    </div>
    <div class="controls">
        <div class="switch" (click)="onEnableC3toC5DrugsToggleClick()">
            <img class="toggle-switch" [class.hidden]="enableC3toC5Drugs" src="assets/icons/icon-slide-switch-is-off.svg"
                alt="off" title="off" />
            <img class="toggle-switch" [class.hidden]="!enableC3toC5Drugs" src="assets/icons/icon-slide-switch-is-on.svg"
                alt="on" title="on" />
        </div>
        <app-button class="edit" *ngIf="enableC3toC5Drugs && (enableC3toC5DrugsValue$ | async)?.DrugsOfInterestType === DrugActivitiesToTrackEnum.AllAndDrugsOfInterest"
            styleClass="settings" subStyle="blue" [minWidth]="0"
            (clicked)="edit()">
            Edit
        </app-button>
    </div>
    </div>

  <ng-template #drugsAll>
    <div class="template">
      <div>Tracks all controlled substances and drugs of interest</div>
      <div class="description">Tracking schedule III, IV, V {{getAllDrugDescriptionExtension()}}</div>
    </div>
  </ng-template>
  <ng-template #drugsSelected>
    <div class="template">
      <div>Track CA-Board requirements only - drug NDCs that match the following descriptions and strengths</div>
      <ul class="description list-disc ml-6 pt-2">
        <li>Alprazolam 1 mg</li>
        <li>Alprazolam 2 mg</li>
        <li>Tramadol 50 mg</li>
        <li>Promethazine-Codeine 6.25-10 mg/ 5ml</li>
      </ul>
    </div>
  </ng-template>


  <app-enable-c3-c5-workflow *ngIf="!(loading$ | async) && runEnableC3C5Workflow" #enableC3C5Workflow
    [updateDrugsOfInterest]="editDrugsOfInterest"
    (cancel)="runEnableC3C5Workflow = false"
    (save)="drugsToTrackSelected($event)"
  ></app-enable-c3-c5-workflow>
